import { Reveal } from "@/components/Reveal";
import { SectionTitle } from "@/components/Practice";

const CHAPTERS = [
  {
    n: "No. 01",
    title: "Performance is engineered, not hoped for.",
    body: "Organizations don't drift into better results. They are designed there — through strategy, disciplined transformation, and financial clarity.",
  },
  {
    n: "No. 02",
    title: "Buyers deserve direct access to suppliers.",
    body: "Procurement should not be a maze of intermediaries. List the requirement, reach the supplier, close the gap.",
  },
  {
    n: "No. 03",
    title: "Advisory means staying at the table.",
    body: "We don't hand over a deck and leave. Transformation is a practice — and a practice is something you keep doing.",
  },
];

export default function EditorsLetter() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="border-t border-[#E5E5DE] py-20 md:py-28">
      <SectionTitle kicker="Our Beliefs" title="The eProcure Manifesto" />
      <div className="max-w-3xl mx-auto px-6 mt-16">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div data-testid={`chapter-${c.n.slice(-2)}`} className="border-t border-[#E5E5DE] py-12 text-center">
              <p className="text-[11px] font-semibold tracking-[0.35em] uppercase text-[#4C8C1E]">{c.n}</p>
              <h3 className="mt-4 font-serif text-3xl md:text-4xl leading-[1.2] text-[#16180F]">{c.title}</h3>
              <p className="mt-5 text-base font-light text-[#55564A] leading-relaxed max-w-xl mx-auto">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
